<template>
  <div id="App">
    <Header />
    <div class="main">
      <transition :name="transitionName">
        <keep-alive>
          <router-view :key="$route.name"></router-view>
        </keep-alive>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

const DEFAULT_TRANSITION = 'fade'
export default {
  name: 'app',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      loading: 0,
      allowPWAi: false,
      transitionName: DEFAULT_TRANSITION,
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      if (from.meta.back && to.meta.back) this.transitionName = 'blend'
      else this.transitionName = from.meta.back ? 'slide-right' : 'slide-left'

      next()
    })

    // Detects if device is on iOS

    const userAgent = window.navigator.userAgent.toLowerCase()
    let isIos = userAgent.indexOf('ipad') > -1 ? 'ipad' : false
    isIos = userAgent.indexOf('iphone') > -1 ? 'iphone' : false
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)
    const pwaDontShow = window.localStorage.getItem('pwaDontShow') || false
    // Checks if should display install popup notification:
    if (isIos && !isInStandaloneMode() && !pwaDontShow) {
      this.allowPWAi = isIos
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.state.user.isLoggedIn
    },
    user () {
      return this.$store.state.user.data
    },
    route () {
      return this.$route.name
    },
  },
  watch: {
    isLoggedIn (isLoggedIn) {
      this.checkUserState(isLoggedIn, this.user)
      if (this.allowPWAi && isLoggedIn) {
        this.$toasted.show('Trykk på deleknappen og velg Legg til på startsiden', {
          theme: 'outline',
          position: this.allowPWAi === 'ipad' ? 'top-right' : 'bottom-center',
          duration: 10000,
          fullWidth: this.allowPWAi !== 'ipad',
          closeOnSwipe: true,
          className: 'pwa',
          iconPack: 'custom-class',
          icon: 'd4-ios-share',
          action: [
            {
              text: 'Ignorer',
              onClick (e, toastObject) {
                window.localStorage.setItem('pwaDontShow', true)
                toastObject.goAway(0)
              },
            },
            {
              text: 'Takk!',
              onClick (e, toastObject) {
                toastObject.goAway(0)
              },
            },
          ],
        })

        this.allowPWAi = false
      }
    },
    user (user) {
      this.checkUserState(this.isLoggedIn, user)
    },
  },
  methods: {
    checkUserState (isLoggedIn, user) {
      if (!isLoggedIn) {
        if (this.route !== 'login') this.$router.replace({ name: 'login' })
      } else if (!user && this.route !== 'register') this.$router.replace({ name: 'register' })
      else if (this.route === 'login' || this.route === 'register') this.$router.replace({ name: 'home' })
    },
  },
}
</script>

<style lang="scss">
@import 'assets/styles';

#App {
  width: 100vw;
  position: fixed;
  height: 100%;
  bottom: 0;
  display: flex;
  flex-direction: column;

  .main {
    position: relative;
    flex-grow: 1;
    background: var(--white);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
    overflow-y: scroll;
  }
}
.toasted.pwa {
  padding: 10px;
  font-size: 14rem;
  font-weight: 400;

  i {
    font-size: 30rem;
  }

  a.action {
    font-size: 8rem;
  }
}
</style>
